import { formatChartDate } from '@/shared/utils/dateFormatters';
import { useIntl } from 'react-intl';

type DateCellProps = {
  value: string,
}

const DateCell = (props: DateCellProps) => {
  const intl = useIntl();
  const { value } = props;
  return <span className='xl:whitespace-nowrap'>
    {formatChartDate({ date: value, locale: intl.locale })}
  </span>
}

export default DateCell;